<script>
  import { user } from "../../stores/User"
  import { BASE_URL } from "../../stores/BASE_URL"
  import SinInformacion from "../../components/Sin_informacion.svelte"
  import Spinner from "../../components/Spinner.svelte"
  import { navigate } from "svelte-routing"

  export let documento

  let data = {
    persona: undefined,
    loading: false,
  }

  let session_key = $user.session_key
  const ops = "general_independientes"

  const cargarDatos = async () => {
    data.loading = true
    const response = await fetch(
      `${BASE_URL}persona.php?documento=${documento}&session_key=${session_key}&ops=${ops}`,
    )
    const resp = await response.json()

    if (resp.status == "error") {
      navigate("/", { replace: true })
    }

    data = {
      persona: resp.data,
      loading: false,
    }
  }

  cargarDatos()
</script>

{#if data.loading === true}
  <Spinner />
{:else if data.persona.length === 0}
  <SinInformacion />
{:else if data.persona !== undefined}
  <div class="table-responsive">
    <table class="table table-striped table-sm">
      <tbody>
        <tr>
          <th class="fg-secondary fw-normal">RUC</th>
          <td colspan="3">{data.persona.ruc}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Tipo</th>
          <td colspan="3">{data.persona.tipo}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Giro</th>
          <td colspan="3">{data.persona.giro}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Fecha Inscripción</th>
          <td colspan="3">{data.persona.fecha_inscripcion}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Fecha Inicio</th>
          <td>{data.persona.fecha_inicio}</td>
          <th class="fg-secondary fw-normal">Fecha Baja</th>
          <td>{data.persona.fecha_baja}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Profesión</th>
          <td colspan="3">{data.persona.profesion}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Estado</th>
          <td>{data.persona.estado}</td>
          <th class="fg-secondary fw-normal">Condición</th>
          <td>{data.persona.condicion}</td>
        </tr>
      </tbody>
    </table>
  </div>
{/if}
